module.exports = __webpack_public_path__ + "static/full-width-image-rolling-025dfbc55e3460c42c1bea1c48730ab9.jpg";